<template>
    <div class="MyPoints">
        <div class="schemeCard p-3">
            <h6 class="mb-1 text-left"> My Points</h6>
            <div class="row">
                <div class="col-6">
                    <div class="eligible-section">
                        <h3>{{schemeEnrollmentObj.eligiblePoint-schemeEnrollmentObj.earnPoint}} </h3>
                        <p>Eligible</p>
                    </div>
                </div>
                <div class="col-6">
                    <div class="eligible-section" style="border: none;">
                        <h3>{{schemeEnrollmentObj.earnPoint}}</h3>
                        <p>Earned</p>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
  export default {
    name: 'MyPoints',
    props: ['schemeEnrollmentObj', 'schemeDetail'],
  }
</script>

<style scoped>

</style>
